import Vue from 'vue'
import api from '@/apis/siteProxyPlayback'
import {
  RESET_STATE,
  PROCESS_API_SUCCESS,
  PROCESS_API_FAILURE,

  // POST
  CREATE_EDGE_PLAYBACK_FROM_PROXY_REQUEST,
  CREATE_EDGE_PLAYBACK_FROM_PROXY_SUCCESS,
  CREATE_EDGE_PLAYBACK_FROM_PROXY_FAILURE,

  GET_EDGE_PLAYBACK_FROM_PROXY_REQUEST,
  GET_EDGE_PLAYBACK_FROM_PROXY_SUCCESS,
  GET_EDGE_PLAYBACK_FROM_PROXY_FAILURE,
} from '@/store/mutation-types'

let initialState = {
  siteEdgePlaybackInfo: {},
  status: {
    createEdgePlayback: null,
    getEdgePlayback: null,
  },
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  siteEdgePlaybackInfo: function (state) {
    return state.siteEdgePlaybackInfo
  },
}

// actions
const actions = {
  // CHEKT-1406: 백엔드가 카메라 device_id로 브릿지·채널을 도출하고 요청자 신원도 인증 정보에서 채운다.
  createEdgePlaybackFromProxy: function ({commit}, {siteId, deviceId, stime, etime}) {
    commit(CREATE_EDGE_PLAYBACK_FROM_PROXY_REQUEST)
    return new Promise((resolve, reject) => {
      api.createEdgePlaybackFromProxy({siteId, deviceId, stime, etime}).then(
        res => {
          let data = res.body
          commit(CREATE_EDGE_PLAYBACK_FROM_PROXY_SUCCESS, {data})
          resolve()
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(CREATE_EDGE_PLAYBACK_FROM_PROXY_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })
  },
  getEdgePlaybackFromProxy: function ({commit}, {siteId, bridgeId, channel}) {
    commit(GET_EDGE_PLAYBACK_FROM_PROXY_REQUEST)
    return new Promise((resolve, reject) => {
      api.getEdgePlaybackFromProxy({siteId, bridgeId, channel}).then(
        res => {
          let data = res.body
          commit(GET_EDGE_PLAYBACK_FROM_PROXY_SUCCESS, {data})
          resolve()
          commit(PROCESS_API_SUCCESS)
        },
        err => {
          commit(GET_EDGE_PLAYBACK_FROM_PROXY_FAILURE)
          reject({
            status: err.status,
            statusText: err.body,
          })
          commit(PROCESS_API_FAILURE, {
            status: err.status,
            statusText: err.body,
            origin: window.location.origin,
            err: Vue.tool.parseToStringify(err),
          })
        }
      )
    })
  },
}

// mutations
const mutations = {
  [RESET_STATE]: function (state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f])
    }
  },
  [CREATE_EDGE_PLAYBACK_FROM_PROXY_REQUEST]: function (state) {
    state.status.createEdgePlayback = 'requested'
  },
  [CREATE_EDGE_PLAYBACK_FROM_PROXY_SUCCESS]: function (state) {
    state.status.createEdgePlayback = 'successful'
  },
  [CREATE_EDGE_PLAYBACK_FROM_PROXY_FAILURE]: function (state) {
    state.status.createEdgePlayback = 'failed'
  },
  [GET_EDGE_PLAYBACK_FROM_PROXY_REQUEST]: function (state) {
    state.status.getEdgePlayback = 'requested'
  },
  [GET_EDGE_PLAYBACK_FROM_PROXY_SUCCESS]: function (state, {data}) {
    state.status.getEdgePlayback = 'successful'
    state.siteEdgePlaybackInfo = data
  },
  [GET_EDGE_PLAYBACK_FROM_PROXY_FAILURE]: function (state) {
    state.status.getEdgePlayback = 'failed'
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}